// Import dependencies
import React from 'react';

// Import CSS & assets
import './CTA.css';


const CTA = () => {

    //Email
    function prepareEmail() {
        var subject = "Demande d'information";
        var body = "Bonjour,\r\n\r\nJe souhaite avoir plus d'information sur Proplab.\r\n\r\nMerci de me recontacter à ce sujet.";
        var uri = "mailto:hello@proplab.fr?subject=";
        uri += encodeURIComponent(subject);
        uri += "&body=";
        uri += encodeURIComponent(body);
        window.open(uri);
    }


    return (
        <div className="landing__cta section__padding">
            <div className="landing__cta_container">
                <div className="landing__cta_content">
                    <p>Essayez notre solution</p>
                    {/* <p onClick={() => { document.getElementById('contact').scrollIntoView() }}>Demander une démonstration</p> */}
                    <h3>Inscrivez-vous dès aujourd'hui et commencez à explorer des possibilités infinies. Contactez-nous.</h3>
                </div>
                <div className="landing__cta_btn">
                    {/* <button type="button" onClick={() => { document.getElementById('contact').scrollIntoView(); document.getElementById('message').value = "Bonjour,\nJe souhaiterais planifier une démonstration de votre solution." }}>Demander une démonstration</button> */}
                    {/* <button type="button" onClick={() => { window.location.replace('/auth?type=signup'); }}>Essayer gratuitement</button> */}
                    <button type="button" onClick={() => { prepareEmail() }}>hello@proplab.fr</button>
                </div>
            </div>
        </div>
    );
};

export default CTA;